import { HYPHEN_MINUS, LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';
import { convertCurrencyToSymbol } from '@dealstack/shared/lib/format/currency/currency';
import { CurrencyType } from '@dealstack/shared/lib/generated';
import { Text, TextProps } from '@mantine/core';
import { NumericFormat } from 'react-number-format';

interface Props {
	className?: string;
	value?: number | string | null;
	currency?: CurrencyType;
	showCurrency?: boolean;
	withMinusSymbol?: boolean;
	showNegative?: boolean;
	showZero?: boolean;
	decimalScale?: number;
	textProps?: TextProps;
}

export const AmountFormatted = ({
	value,
	showNegative,
	currency,
	showZero,
	withMinusSymbol,
	showCurrency = true,
	className,
	decimalScale = 2,
	textProps,
}: Props) => {
	if (value == null || !currency) {
		return <>{LONG_DASH}</>;
	}

	const inputValue = Number(value);

	const isNegativeValue = inputValue < 0;
	const getShownValue = () => {
		if (!isNegativeValue) {
			return inputValue;
		}
		return showNegative ? Math.abs(inputValue) : 0;
	};
	const shownValue = getShownValue();

	if (shownValue === 0 && !showZero) {
		return <>{HYPHEN_MINUS}</>;
	}

	const showMinusSymbol = withMinusSymbol || (isNegativeValue && showNegative);

	return (
		<NumericFormat
			displayType="text"
			thousandSeparator
			value={shownValue.toString()}
			decimalScale={decimalScale}
			fixedDecimalScale
			prefix={`${showCurrency ? convertCurrencyToSymbol(currency) : ''} ${showMinusSymbol ? '(' : ''}`}
			suffix={showMinusSymbol ? ')' : ''}
			className={className}
			renderText={(formattedValue) => <Text {...textProps}>{formattedValue}</Text>}
		/>
	);
};
